module.exports = __webpack_public_path__ + "media/images/ticket/view_cart_ov-a6e2fa171b490a33c168e50a1d45ee85.png";